import { motion } from "framer-motion";
import { MaskedLines } from "@/components/Reveal";

export default function PageHero({ eyebrow, title, lines = [], lead, image, imageAlt = "" }) {
  return (
    <section className="pt-36 pb-16 lg:pt-44 lg:pb-24 bg-cream" data-testid="page-hero">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7">
          <p className="font-serif italic text-xl sm:text-2xl text-gold mb-6">
            {eyebrow}
          </p>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-ink">
            <MaskedLines lines={lines.length ? lines : [title]} />
          </h1>
          {lead && (
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.9, delay: 0.5 }}
              className="mt-8 text-base sm:text-lg text-taupe leading-relaxed max-w-xl"
            >
              {lead}
            </motion.p>
          )}
        </div>
        {image && (
          <motion.div
            initial={{ opacity: 0, scale: 0.96 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1.1, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
            className="lg:col-span-5"
          >
            <div className="img-frame">
              <img
                src={image}
                alt={imageAlt}
                data-testid="page-hero-image"
                className="w-full object-cover aspect-[4/5] max-h-[560px]"
              />
            </div>
          </motion.div>
        )}
      </div>
    </section>
  );
}
